import { jsx as r } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { CAPITAL_OVERVIEW_CLASS_NAMES as a } from "../constants.js";
import n from "../../../internal/Button/Button.js";
import m from "../../../../core/Context/useCoreContext.js";
import p from "../../../internal/Typography/Typography.js";
import { TypographyVariant as l } from "../../../internal/Typography/types.js";
import u from "../../../internal/InfoBox/InfoBox.js";
import { Fragment as s } from "../../../../external/preact/dist/preact.module.js";
import { CapitalHeader as c } from "../../../internal/CapitalHeader/CapitalHeader.js";
const F = ({
  dynamicOfferConfig: t,
  hideTitle: i,
  onOfferOptionsRequest: o
}) => {
  const { i18n: e } = m();
  return /* @__PURE__ */ r(s, { children: [
    /* @__PURE__ */ r(c, { hideTitle: i, titleKey: "capital.needSomeExtraMoney" }),
    /* @__PURE__ */ r("div", { className: a.preQualifiedGrant, children: [
      /* @__PURE__ */ r(u, { children: /* @__PURE__ */ r(p, { variant: l.BODY, children: [
        e.get("capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1"),
        /* @__PURE__ */ r("strong", { children: e.get("capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2", {
          values: {
            amount: e.amount(t.maxAmount.value, t.maxAmount.currency, {
              minimumFractionDigits: 0
            })
          }
        }) })
      ] }) }),
      /* @__PURE__ */ r(n, { className: a.preQualifiedGrantButton, onClick: o, children: e.get("capital.seeOptions") })
    ] })
  ] });
};
export {
  F as default
};
